// extracted by mini-css-extract-plugin
export default {"iconezap":"IconeZapZap_iconezap__CHUkn","wiggle":"IconeZapZap_wiggle__nsnmS"};